let pressCommand = false;
let keydownName = '';

export const getKeyDownName = () => keydownName;

window.addEventListener(
    'blur',
    () => {
        pressCommand = false;
    },
    false,
);
document.addEventListener('keydown', (e: KeyboardEvent) => {
    const key = e.key?.toLocaleLowerCase();
    if ((e.metaKey && key === 'meta') || (e.ctrlKey && key === 'control') || (e.shiftKey && key === 'shift')) {
        pressCommand = true;
    }
    keydownName = e.key;
});
document.addEventListener('keyup', (e: KeyboardEvent) => {
    const key = e.key?.toLocaleLowerCase();
    if (!e.metaKey && !e.ctrlKey && !e.shiftKey) {
        pressCommand = false;
    } else if (e.metaKey && key === 'meta' && !e.ctrlKey && !e.shiftKey) {
        // fix: 嵌套在 mac 客户端里在 keyup 时 metaKey=true 导致判断失效
        pressCommand = false;
    } else if (e.ctrlKey && key === 'control' && !e.metaKey && !e.shiftKey) {
        pressCommand = false;
    } else if (e.shiftKey && key === 'shift' && !e.ctrlKey && !e.metaKey) {
        pressCommand = false;
    }
    keydownName = '';
});

/**
 * 是否按住 ctrl 或 command
 * @returns
 */
export const isHotKeyPress = () => {
    return pressCommand;
};
